import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../models/app-config';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;

  allPermissions = {
    "ResourceId": 1372,
    "ResourceName": "FBI-ADN",
    "ResourceActions": [
      {
        "ActionTypeId": 1,
        "Description": "Acceso",
        "AllowChk": false
      }
    ],
    "ResourceNodes": [
      {
        "ResourceId": 1374,
        "ResourceName": "adnNewCandidate",
        "ResourceActions": [
          {
            "ActionTypeId": 1,
            "Description": "Acceso",
            "AllowChk": true
          }
        ]
      },
      {
        "ResourceId": 1725,
        "ResourceName": "ADN - NewProcess",
        "ResourceActions": [
          {
            "ActionTypeId": 1,
            "Description": "Acceso",
            "AllowChk": true
          }
        ]
      },
      {
        "ResourceId": 1726,
        "ResourceName": "ADN - NewPerfilTipo",
        "ResourceActions": [
          {
            "ActionTypeId": 1,
            "Description": "Acceso",
            "AllowChk": true
          }
        ]
      },
      {
        "ResourceId": 4008,
        "ResourceName": "RtaExportScores",
        "ResourceActions": [
          {
            "ActionTypeId": 10,
            "Description": "GET",
            "AllowChk": true
          }
        ]
      },
      {
        "ResourceId": 4011,
        "ResourceName": "RtaExportReports",
        "ResourceActions": []
      }
    ],
    "BegDateControllerProccess": new Date("19/12/2023 13:10:35"),
    "BegDateDSProccess": new Date("18/12/2023 14:25:51"),
    "BegDateQueryProccess": new Date("18/12/2023 14:25:51"),
    "EndDateQueryProccess": new Date("18/12/2023 14:25:51"),
    "QueryProccessTotalTime": 0.0044412,
    "EndDateDSProccess": new Date("18/12/2023 14:25:51"),
    "DSProccessTotalTime": 0.0599306,
    "EndDateControllerProccess": new Date("19/12/2023 13:10:35"),
    "ControllerProccessTotalTime": 0.0281911,
    "ErrorDynamoDbMessage": null,
    "PermissionSource": "DynamoDb"
  };

  constructor(private http: HttpClient) { }

  load() {
    const jsonFile = '/cfg/environment.json';
    return new Promise<void>((resolve, reject) => {
      this.http.get(jsonFile).toPromise().then((response: IAppConfig) => {
        AppConfig.settings = response;
        AppConfig.settings.ALL_PERMISSIONS = this.allPermissions;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      });
    });
  }

}
